export default "__VITE_ASSET__407a772e__"